import React, { Component } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CustomLoader from '../../../common/CustomLoader';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import * as actions from '../../redux/actions';
import history from '../../../../common/history';
import * as externalApiActions from '../../../external-api/redux/actions';
import { getFilteredArray, processSessionKeyMapping } from '../sendDataToExternalApi/util';
import voca from 'voca';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import { getFieldInfoByName } from '../collection/Util';
import { handleConstantActionParams } from './util';

class ExternalSourceActionForm extends Component {
  state = {
    params: [],
    formDataParams: [],
    showAdvanceForPreviousActionFormData: false,
    showAdvanceForPreviousActionResponse: false,
  };

  componentDidMount() {
    const { projectId, eventAction, version } = this.props;
    this.props.externalApiActions.loadExternalApis({ projectId, version });
    const dbParams = eventAction.parameters.find((param) => {
      return param.name === 'overriddenSessionKeyRules';
    });
    const dbFormParams = eventAction.parameters.find((param) => {
      return param.name === 'overriddenSessionFormDataKeyRules';
    });

    this.setState({
      ...this.state,
      params:
        dbParams && !voca.isEmpty(dbParams.value)
          ? dbParams.value
          : [{ id: 1, originalSessionKey: '', overriddenSessionKey: '' }],
      formDataParams:
        dbFormParams && !voca.isEmpty(dbFormParams.value)
          ? dbFormParams.value
          : [{ id: 1, originalSessionKey: '', overriddenSessionKey: '' }],
    });
  }

  createNewParamRow = (rowObj) => {
    const params = processSessionKeyMapping(this.state.params, rowObj);
    this.setState({ params });
  };

  createNewFormDataParamRow = (rowObj) => {
    const formDataParams = processSessionKeyMapping(this.state.formDataParams, rowObj);
    this.setState({ formDataParams });
  };

  createActionSettingsSchema = (actionData, eventAction) => {
    let schema = {};
    actionData.args.forEach((args) => {
      const dbParameters = eventAction.parameters.find((param) => {
        return param.name === args.name;
      });
      handleConstantActionParams(args, schema, dbParameters);
    });
    return schema;
  };

  handleSubmit = (values) => {
    const { actionData, eventAction, actions, projectId, version, selectedEvent } = this.props;
    const { params, formDataParams } = this.state;

    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      if (action) {
        parameters.push({ name: value, value: values[value], type: action.type });
      }
    });

    parameters.push({
      name: 'overriddenSessionKeyRules',
      value: getFilteredArray(params),
      type: 'array',
    });
    parameters.push({
      name: 'overriddenSessionFormDataKeyRules',
      value: getFilteredArray(formDataParams),
      type: 'array',
    });

    let actionFormData = eventAction;
    actionFormData.parameters = parameters;

    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    this.props.hideModal();
  };

  externalApiOptions = () => {
    let options = [];
    const { externalapi, externalApiType } = this.props;
    const { externalApis } = externalapi ? externalapi : '';
    if (externalApis.length > 0) {
      if (externalApiType) {
        options = options.concat(
          externalApis
            .filter((externalApi) => externalApi.externalApiType === externalApiType)
            .map((externalAPI) => {
              return { value: externalAPI.uuid, label: externalAPI.externalApiName };
            }),
        );
      } else {
        options = options.concat(
          externalApis.map((externalAPI) => {
            return { value: externalAPI.uuid, label: externalAPI.externalApiName };
          }),
        );
      }
    }
    return options;
  };

  closeAllOpenPopup = () => {
    const { projectId, actions, version } = this.props;
    actions.closeActionFormModal();
    history.push(`/externalapi/${version}/v/${projectId}/create`);
  };

  advanceOptionHandler = (event, name) => {
    if (name === 'passPreviousActionFormData') {
      this.setState({
        showAdvanceForPreviousActionFormData: !this.state.showAdvanceForPreviousActionFormData,
      });
    }
    if (name === 'passPreviousActionResponse') {
      this.setState({
        showAdvanceForPreviousActionResponse: !this.state.showAdvanceForPreviousActionResponse,
      });
    }
  };

  render() {
    const { eventAction, actionData, externalApiType } = this.props;
    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.createActionSettingsSchema(actionData, eventAction)}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
          <Form>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="External API"
                    icon="select"
                    infoIcon={true}
                    infoDescription={getFieldInfoByName('externalAPI')}
                  >
                    <CustomSelect
                      name={'webhookId'}
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={this.externalApiOptions()}
                      value={values['webhookId']}
                      onChangeValue={this.handleChange}
                      placeholder={`${
                        externalApiType ? voca.titleCase(externalApiType) + ' ' : ''
                      }External API`}
                    />
                    <ErrorMessage name={'webhookId'}>
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Success Message"
                    icon="text"
                    infoIcon={true}
                    infoDescription={`Enter Success message (optional) you want to display on successful execution.`}
                  >
                    <Field
                      type="text"
                      name="successMessage"
                      className="form-control form-control-sm"
                      autoComplete="off"
                      placeholder="(Optional) Success Message"
                    />
                    <ErrorMessage name="successMessage">
                      {(msg) => <p className="texterror">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 text-left">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={this.props.hideModal}
                >
                  <span>
                    <i className="wb webconnect-times"></i> Cancel
                  </span>
                </button>
              </div>
              <div className="col-md-6 text-right">
                <button type="submit" className="btn btn-theme-submit btn-sm">
                  <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                  <CustomLoader loading={this.props.showLoaderForAction} />
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return {
    event: state.event,
    externalapi: state.externalapi,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    externalApiActions: bindActionCreators({ ...externalApiActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalSourceActionForm);
